import * as _ from 'lodash';
import {PageSectionData} from '~/types';
import HeroBanner from './Sections/HeroBanner';
import {SECTION_TYPES} from '~/utils';
import ImageDetail from './Sections/ImageDetail';
import HeaderBanner from './Sections/HeaderBanner';
import ProductsList from './Sections/ProductsList';
import ArticleList from './Sections/ArticleList';
import FAQSection from './Sections/FAQSection';
import Features from './Sections/Features';

const ComponentUtil = ({
  pageSections,
  collectionProducts,
  articles,
  language,
  country,
  allFaqs,
  blocks,
  ...rest
}: {
  pageSections: PageSectionData[];

  [x: string]: any;
}) => {
  const renderBlock = (block: PageSectionData) => {
    switch (_.get(block, 'style', '')) {
      case SECTION_TYPES.FAQS:
        return <FAQSection faqs={allFaqs} />;
      case SECTION_TYPES.ARTICLES:
        return (
          <ArticleList
            articles={articles}
            language={language}
            country={country}
          />
        );
      case SECTION_TYPES.PRODUCTS:
        return (
          <ProductsList collectionProducts={collectionProducts} {...rest} />
        );
      case SECTION_TYPES.HERO_SECTION:
        return (
          <HeroBanner
            title={_.get(block, 'title', '')}
            rich_text={_.get(block, 'text', '')}
            imageUrl={_.get(block, 'media', '')}
            cta_label={_.get(block, 'ctaLabel', '')}
            cta_link={_.get(block, 'ctaLink', '')}
          />
        );
      case SECTION_TYPES.FEATURES:
        return <Features features={_.get(block, 'features', '')} />;
      case SECTION_TYPES.IMAGE_TEXT:
        return (
          <ImageDetail
            image={_.get(block, 'media', '')}
            content={_.get(block, 'text', '')}
            title={_.get(block, 'title', '')}
            image_left={true}
            cta_label={_.get(block, 'ctaLabel', '')}
            cta_link={_.get(block, 'ctaLink', '')}
          />
        );
      case SECTION_TYPES.TEXT_IMAGE:
        return (
          <ImageDetail
            image={_.get(block, 'media', '')}
            content={_.get(block, 'text', '')}
            title={_.get(block, 'title', '')}
            image_left={false}
            cta_label={_.get(block, 'ctaLabel', '')}
            cta_link={_.get(block, 'ctaLink', '')}
          />
        );

      default:
        return null;
    }
  };
  return (
    <>
      {_.map(
        _.uniqBy(blocks, (e) => _.get(e, 'id')),
        (block, idx) => (
          <section key={`${_.get(block, 'id')}-${idx}`}>
            {renderBlock(block)}
          </section>
        ),
      )}
    </>
  );
};

export default ComponentUtil;
